const PRODUCT_ID_PATTERN = /^[1-9]\d*$/;

/**
 * The recently-viewed cookie stores `id|id|…`. Keeps positive integer ids only, first occurrence
 * first, so a corrupt or duplicated entry never reaches a product lookup.
 */
export function parseRecentlyViewedProductIds(raw?: string | null): string[] {
  return [...new Set((raw ?? '').split('|').filter((id) => PRODUCT_ID_PATTERN.test(id)))];
}
